module.exports = __webpack_public_path__ + "static/media/universal_assistance.973afdfc.svg";